import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatbotReplyWithChatId } from '../buddy-services/chatbot.reply';

@Component({
    selector: 'buddy-single-answer',
    styleUrls: ['buddy-single-answer.component.scss'],
    templateUrl: 'buddy-single-answer.component.html',
})
export class BuddySingleAnswerComponent {
    @Input() answer$: Observable<ChatbotReplyWithChatId>;
    @Output() chatSelected = new EventEmitter<string>();

    @Input() pressed = false;
    errorText: string = $localize`:@@components.buddy-single-answer.error-text:Missing translation`;

    onAnswerClick(chatId: string): void {
        this.pressed = true;
        this.chatSelected.emit(chatId);
    }
}
